module.exports = __webpack_public_path__ + "img/mr.590ed6c0.png";